/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
// require('./quill.js');

window.Vue = require('vue');
window.Quill = require('Quill');

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCarousel from 'vue-carousel';
import VueAxios from 'vue-axios';
import VueGtag from "vue-gtag";
import axios from 'axios';
import VTooltip from 'v-tooltip'
import Datepicker from 'vuejs-datepicker';


// Google Analytics
Vue.use(VueGtag, {
	config: {
		id: 'G-RW4ESJ5QCW',
		params: {
			send_page_view: false
		}
	}
}, router);

// VTooltip.defaultTrigger = 'click'

Vue.use(VueAxios, axios);
Vue.use(VTooltip, {
	defaultTrigger: (window.innerWidth > 768) ? 'hover' : 'click'
});
Vue.use(VueRouter);
Vue.use(VueCarousel);

Vue.axios.defaults.baseURL = document.head.querySelector('meta[name="api-base-url"]').content;

import * as Sentry from '@sentry/vue';

Sentry.init({
	Vue,
	dsn: document.head.querySelector('meta[name="sentry-dsn"]').content,
	attachProps: true,
	logErrors: true,
});

// Global eventHub/eventBus
Vue.prototype.$eventHub = new Vue();
Vue.prototype.$eventBus = new Vue();

// Global URL's
Vue.prototype.baseUrl = Vue.axios.defaults.baseURL;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Components
import twModal from './components/tailwind-elements/overlays/modal.vue'; 			// Tailwind modal
import twInput from './components/tailwind-elements/form/input.vue'; 				// Tailwind form input
import twToggleGroup from './components/tailwind-elements/form/toggleGroup.vue'; 	// Tailwind toggle group
import twCheckbox from './components/tailwind-elements/form/checkbox.vue'; 			// Tailwind checkbox
import twButton from './components/tailwind-elements/elements/button.vue'; 			// Tailwind button
import twDropdown from './components/tailwind-elements/elements/dropdown.vue'; 		// Tailwind dropdown
import twCard from './components/tailwind-elements/layout/card.vue'; 				// Tailwind card
import twAlert from './components/tailwind-elements/feedback/alert.vue'; 			// Tailwind alert
import twTitle from './components/tailwind-elements/headings/cardHeading.vue'; 		// Tailwind card heading
import twSlideover from './components/tailwind-elements/overlays/slideover.vue'; 	// Tailwind slideover
import twTabs from './components/tailwind-elements/navigation/tabs.vue'; 			// Tailwind tabs
import twSelect from './components/tailwind-elements/form/dropdown.vue'; 			// Tailwind select dropdown
import noData from './components/tailwind-elements/feedback/no-data.vue'; 			// No data
import tooltip from './components/inc/tooltip.vue'									// Tooltip
import loading from './components/inc/loading.vue'; 								// Loading gif
import initialQuote from './components/quote/initial/main.vue'; 					// Initial quote - used to create a form so users can quickly get a price
import quoteForm from './components/quote/form.vue';								// Quote - overall container for all stages of quote
import quotePolicyOptions from './components/quote/policyOptions.vue';				// Quote - policy options
import quoteContact from './components/quote/contactDetails.vue';					// Quote - contact details
import quoteDeclaration from './components/quote/declaration.vue';					// Quote - declaration
import quotePayment from './components/quote/payment.vue';							// Quote - payment
import policyConfirm from './components/quote/policy.vue';							// Policy - confirmation
import subscribe from './components/inc/subscribe';									// Subscribe
import competitorsTable from './components/tables/competitors.vue';					// Competitors Table
import retrieveQuote from './components/quote/retrieveQuote.vue'; 					// Retrieve quote - used to pull existing quotes
import navLink from './components/inc/navLink.vue'; 								// NavLink
import comparisonLogin from './components/quote/comparisonLogin.vue';  				// Comparison - Login
import comparisonVerify from './components/quote/comparisonVerify.vue';  			// Comparison - Verify
import twFormGroup from './components/tailwind-elements/form-group'
import twRadioOption from './components/tailwind-elements/radio-option'
import TwLoader from './components/tailwind-elements/loader'; 
import PolicySelection from './components/quote/PolicySelection'; 
import claimsForm from './components/claims/form.vue'; 


// Global components

Vue.component('policySelection', PolicySelection);

Vue.mixin({
	data: () => ({
		isLoading: false,
		baseUrl: document.head.querySelector('meta[name="base-url"]').content,
	}),
	components: {
		twModal,
		twInput,
		twDropdown,
		twCheckbox,
		twButton,
		twToggleGroup,
		twCard,
		twAlert,
		twTitle,
		twSlideover,
		Datepicker,
		twTabs,
		twSelect,
		tooltip,
		loading,
		noData,
		subscribe,
		competitorsTable,
		navLink,
		twFormGroup,
		twRadioOption,
		TwLoader,
		claimsForm,
	},
	methods: {
		setLoading(isLoading = true) {
			this.isLoading = isLoading;
		},
	}
});



// Global directives
export const slideoverDir = {
	bind(el, binding, vnode) {
		el.addEventListener('click', () => {
			vnode.context.$refs[binding.arg].toggle();
		});
	}
}
export const modalDir = {
	bind(el, binding, vnode) {
		el.addEventListener('click', () => {
			vnode.context.$refs[binding.arg].open();
			document.body.style.overflowY = 'hidden';
		});
	}
}
Vue.directive('tw-slideover', slideoverDir);
Vue.directive('tw-modal', modalDir);

// Global filters
Vue.filter('prettify', function (text) {
	let newText = text;

	// replace dashes
	newText = newText.replace(/-/g, ' ');

	// replace dashes
	newText = newText.replace(/_/g, ' ');

	// capitalize
	newText = newText.charAt(0).toUpperCase() + newText.slice(1);

	return newText;
});
Vue.filter('currency', function (value) {
	return '£' + value.toFixed(2);
});

// Router
const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/quote',
			name: 'quote.quoteForm',
			component: quoteForm,
			redirect: { name: 'quote.cover' },
			children: [
				{
					path: 'cover',
					name: 'quote.cover',
					component: quotePolicyOptions,
				},
				{
					path: 'contact',
					name: 'quote.contact',
					component: quoteContact,
				},
				{
					path: 'declaration',
					name: 'quote.declaration',
					component: quoteDeclaration,
				},
				{
					path: 'payment',
					name: 'quote.payment',
					component: quotePayment,
				},
				{
					path: 'confirm',
					name: 'quote.confirm',
					component: policyConfirm,
				},
			]
		},
		{
			path: '/quote/compare/login',
			name: 'quote.compareLogin',
			component: comparisonLogin,
		},
		{
			path: '/quote/compare/verify',
			name: 'quote.compareVerify',
			component: comparisonVerify,
		},
	],
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
	el: '#app',
	components: {
		initialQuote,
		retrieveQuote,
		Datepicker
	},
	router,
	mounted() {
		// used to resize modals on the fly
		this.$eventBus.$on('resize-modal', (data) => {
			let ref = data.ref;
			let size = data.size;

			this.$refs[ref].setSize(size);
		});

		// used to show users their session has timed out
		this.$eventHub.$on('session-timeout', (error) => {
			this.$refs['session-timeout'].show = true;
		});
	}
});



// Admin sidebar menu (open/close)
$('.open-sidebar-btn').on('click', function () {
	var el = $(this);

	$('.mobile-menu-container').addClass('show');
});
$('.close-sidebar-btn').on('click', function () {
	var el = $(this);

	$('.mobile-menu-container').removeClass('show');
})

// Admin user menu
$('#user-menu').on('click', function () {
	var el = $(this);
	var container = $('.profile-dropdown-panel-container');

	if (container.hasClass('show')) {
		container.removeClass('show');
	} else {
		container.addClass('show');
	}
});
$('#user-menu').on('focusout', function () {
	var el = $(this);
	var container = $('.profile-dropdown-panel-container');

	container.removeClass('show');
});

// Sidepage menu
$('.mobile-menu-btn').on('click', function () {
	var btn = $(this);

	// Button icons
	if (btn.hasClass('open')) {
		btn.removeClass('open');
	} else {
		btn.addClass('open');
	}

	// Sidebar
	var sidebar = $('.secondary-mobile');
	if (sidebar.hasClass('open')) {
		sidebar.removeClass('open');
	} else {
		sidebar.addClass('open');
	}
});

// Reduce menu size when scrolling
var nav = document.getElementById('secondary-desktop-element');
var scrollingY = 300;
if (nav) {
	window.addEventListener('scroll', function () {
		if (window.scrollY >= scrollingY) {
			nav.classList.add('nav-fixed');
		} else {
			nav.classList.remove('nav-fixed');
		}
	});
}

// Quill settings
var editor = $('#editor');
if (editor.length > 0) {
	var options = {
		theme: 'snow'
	};
	var quill = new Quill('#editor', options);
	// Update hidden textarea to mimic quill text editor for easy form submission
	$('body').on('DOMSubtreeModified', '#editor', function () {
		var editor = $('#editor');
		var parent = editor.parent();

		// check if corresponding input for editor has been made
		var input = parent.find('textarea.quill-editor');
		if (input.length == 0) {
			parent.append('<textarea name="body" class="quill-editor"></textarea>');
		}
		// add editor content to textarea
		var input = parent.find('textarea.quill-editor');
		input[0].innerHTML = editor.find('.ql-editor').html();
	});

	// Prepopulate form with existing data
	var content = editor.data('content');
	if (content !== undefined) {
		quill.root.innerHTML = content;
	}
}

// show/hide FAQ
$('.faq-question').on('click', function () {
	var showQuestion = false;
	if (!$(this).hasClass('showing')) {
		showQuestion = true;
	}

	// get showing answer
	var showingAnswer = $('.faq-answer:visible').first();

	// hide showing answer
	showingAnswer.prev('li.faq-question').removeClass('showing');
	showingAnswer.slideUp();

	// show answer
	if (showQuestion) {
		var question = $(this);
		var answer = question.next('li.faq-answer');
		question.addClass('showing');
		answer.slideDown();
	}
});

Vue.axios.interceptors.response.use(response => {
	return response
}, error => {
	if (error && error.hasOwnProperty('response') && error.response.status === 401) {
		app.$eventHub.$emit('session-timeout', error);
	}
	return Promise.reject(error)
})
